@for (toast of toasts(); track toast.id) {
  <sb-toast
    @toastAnimation
    [type]="toast.type"
    [title]="toast.title"
    [message]="toast.message"
    [template]="toast.template"
    [actions]="toast.actions"
    (close)="toast.destroy()"
  />
}
